import { createAction, props } from '@ngrx/store';
import { CatalogState } from './state';

export const LoadCatalogSuccess = createAction(
  '[Catalog] Load Catalog Success',
  props<{ catalog: CatalogState }>()
)

export const LoadCatalogError = createAction(
  '[Catalog] Load Catalog Error',
  props<{ error: any }>()
)
